import React from 'react';
import { Background, Main } from 'styles/themeColors';
import FlexboxContainer from 'components/UI/FlexboxContainer';
import Banner from 'components/UI/Banner';
import Button from 'components/UI/Button';
import { TEXT_LABELS } from 'constants/order';
import { CANCELATION_FAILED } from '../../constants/consignmentStates';

interface Props {
  show: boolean;
  consignmentState: string;
  onRetry?: () => void;
  onReject?: () => void;
  onApprove?: () => void;
}

const SalesOrderCancellationBanner: React.FC<Props> = ({
  show,
  consignmentState,
  onRetry,
  onReject,
  onApprove
}) => {

  if (!show) {
    return null;
  }

  // Build action buttons based on cancellation type
  const buttons = (
    <FlexboxContainer
      flexDirection='row'
      justifyContent='flex-end'
      alignItems='center'
      gap='4px'
      margin='0px'
    >

      <Button
        borderColor={Background.navy}
        bgColor={Main.warning}
        color={Background.navy}
        onClick={onReject}
      >
        {TEXT_LABELS.REJECT_CANCELATION}
      </Button>

      {
        consignmentState === CANCELATION_FAILED ? <Button
          borderColor={Background.navy}
          bgColor={Background.navy}
          onClick={onRetry}
        >
          {TEXT_LABELS.RETRY_CANCELATION}
        </Button> : <Button
          borderColor={Background.navy}
          bgColor={Background.navy}
          onClick={onApprove}
        >
          {TEXT_LABELS.APPROVE_CANCELATION}
        </Button>
      }
    </FlexboxContainer>
  );

  return (
    <Banner
      bgColor={Main.warning}
      title={TEXT_LABELS.CANCELATION_TITLE}
      text={consignmentState === CANCELATION_FAILED ? TEXT_LABELS.CANCELATION_FAILED_TEXT : TEXT_LABELS.CANCELATION_APPROVAL_TEXT}
      buttons={buttons}
    />
  );
};

export default SalesOrderCancellationBanner;